/* -disable array-callback-return */
/* -disable consistent-return */
import React, { Component } from 'react';
import moment from 'moment';
import './styles.css';

import Icon from '../Icon';
import ClearAllFilters from './ClearAllFilters';

export default class CurrentFilters extends Component {
  _renderCurrentFilterItem = ({
    name,
    value,
    clear,
    shouldRenderObject,
    ellipsis = true,
  }) =>
    value.length && !shouldRenderObject ? (
      <div
        className={
          ellipsis
            ? 'CurrentFilters__item-container CurrentFilters__item-container__ellipsis'
            : 'CurrentFilters__item-container'
        }
        title={
          ellipsis &&
          `${name}: ${
            value instanceof Array
              ? value.map(val => val.name.trim()).join(', ')
              : value.trim()
          }`
        }
        onClick={() => {
          clear(true);
        }}
      >
        <span
          className={
            ellipsis
              ? 'CurrentFilters__item-text CurrentFilters__item-text__ellipsis'
              : 'CurrentFilters__item-text'
          }
        >
          {`${name}: ${
            value instanceof Array
              ? value.map(val => val.name.trim()).join(', ')
              : value.trim()
          }`}
        </span>
        <div>
          <Icon name="close" />
        </div>
      </div>
    ) : null;

  _renderObjectFilter = ({
    name,
    value,
    clear,
    shouldRenderObject,
    ellipsis = true,
  }) =>
    shouldRenderObject && Object.values(value).length ? (
      <div
        className={
          ellipsis
            ? 'CurrentFilters__item-container CurrentFilters__item-container__ellipsis'
            : 'CurrentFilters__item-container'
        }
        title={
          ellipsis &&
          `${name}: ${moment(value.initialPeriod).format(
            'DD/MM/YYYY',
          )} a ${moment(value.finalPeriod).format('DD/MM/YYYY')}`
        }
        onClick={clear}
      >
        <span
          className={
            ellipsis
              ? 'CurrentFilters__item-text CurrentFilters__item-text__ellipsis'
              : 'CurrentFilters__item-text'
          }
        >
          {`${name}: ${moment(value.initialPeriod).format(
            'DD/MM/YYYY',
          )} a ${moment(value.finalPeriod).format('DD/MM/YYYY')}`}
        </span>
        <div>
          <Icon name="close" />
        </div>
      </div>
    ) : null;

  render() {
    const {
      filters,
      className = 'CurrentFilters__container',
      clearAllFilters,
    } = this.props;

    const filtersApplied = Object.keys(filters).filter(key => {
      const newFilter =
        filters[key].value.length > 0 ? filters[key].value : null;

      if (newFilter !== null) {
        return newFilter;
      }
    });

    return (
      <div className={className}>
        {Object.keys(filters).map(key => {
          if (filters[key].shouldRenderObject) {
            return this._renderObjectFilter(filters[key]);
          }

          return this._renderCurrentFilterItem(filters[key]);
        })}
        {clearAllFilters && filtersApplied.length > 0 && (
          <ClearAllFilters clearAllFilters={clearAllFilters} />
        )}
      </div>
    );
  }
}
